/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAdminMaintenanceStatusDtoEvent } from '../models/work-admin-maintenance-status-dto-event';

@Injectable({ providedIn: 'root' })
export class WorkAdminMaintenanceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminMaintenanceControllerListenToMaintenanceStatus()` */
  static readonly AdminMaintenanceControllerListenToMaintenanceStatusPath = '/v2/admin/maintenance/status';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminMaintenanceControllerListenToMaintenanceStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMaintenanceControllerListenToMaintenanceStatus$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAdminMaintenanceStatusDtoEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminMaintenanceService.AdminMaintenanceControllerListenToMaintenanceStatusPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/event-stream', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAdminMaintenanceStatusDtoEvent>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminMaintenanceControllerListenToMaintenanceStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMaintenanceControllerListenToMaintenanceStatus(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkAdminMaintenanceStatusDtoEvent> {
    return this.adminMaintenanceControllerListenToMaintenanceStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAdminMaintenanceStatusDtoEvent>): WorkAdminMaintenanceStatusDtoEvent => r.body)
    );
  }

  /** Path part for operation `adminMaintenanceControllerRecalculateAllCalculations()` */
  static readonly AdminMaintenanceControllerRecalculateAllCalculationsPath = '/v2/admin/maintenance/recalculate-all-calculations';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminMaintenanceControllerRecalculateAllCalculations()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMaintenanceControllerRecalculateAllCalculations$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminMaintenanceService.AdminMaintenanceControllerRecalculateAllCalculationsPath, 'patch');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminMaintenanceControllerRecalculateAllCalculations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMaintenanceControllerRecalculateAllCalculations(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.adminMaintenanceControllerRecalculateAllCalculations$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminMaintenanceControllerRecalculateActiveCalculations()` */
  static readonly AdminMaintenanceControllerRecalculateActiveCalculationsPath = '/v2/admin/maintenance/recalculate-active-calculations';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminMaintenanceControllerRecalculateActiveCalculations()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMaintenanceControllerRecalculateActiveCalculations$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminMaintenanceService.AdminMaintenanceControllerRecalculateActiveCalculationsPath, 'patch');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminMaintenanceControllerRecalculateActiveCalculations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMaintenanceControllerRecalculateActiveCalculations(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.adminMaintenanceControllerRecalculateActiveCalculations$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminMaintenanceControllerPrepareLegacyCalculations()` */
  static readonly AdminMaintenanceControllerPrepareLegacyCalculationsPath = '/v2/admin/maintenance/prepare-legacy-calculations';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminMaintenanceControllerPrepareLegacyCalculations()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMaintenanceControllerPrepareLegacyCalculations$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminMaintenanceService.AdminMaintenanceControllerPrepareLegacyCalculationsPath, 'patch');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminMaintenanceControllerPrepareLegacyCalculations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMaintenanceControllerPrepareLegacyCalculations(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.adminMaintenanceControllerPrepareLegacyCalculations$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
